import {
    NEW_FUNCIONARIO_CARGO_CADASTRO_SUCCESS,
    CANCEL_FUNCIONARIO_CARGO_CADASTRO_RAPIDO_SUCCESS,
    TABLE_FUNCIONARIO_CARGO_CADASTRO_PENDING,
    TABLE_FUNCIONARIO_CARGO_CADASTRO_SUCCESS,
    TABLE_FUNCIONARIO_CARGO_CADASTRO_FAILURE,
    LIST_FUNCIONARIO_CARGO_CADASTRO_PENDING,
    LIST_FUNCIONARIO_CARGO_CADASTRO_SUCCESS,
    LIST_FUNCIONARIO_CARGO_CADASTRO_FAILURE,
    FIND_FUNCIONARIO_CARGO_CADASTRO_PENDING,
    FIND_FUNCIONARIO_CARGO_CADASTRO_SUCCESS,
    FIND_FUNCIONARIO_CARGO_CADASTRO_FAILURE,
    DELETE_FUNCIONARIO_CARGO_CADASTRO_PENDING,
    DELETE_FUNCIONARIO_CARGO_CADASTRO_SUCCESS,
    DELETE_FUNCIONARIO_CARGO_CADASTRO_FAILURE,
    CREATE_FUNCIONARIO_CARGO_CADASTRO_PENDING,
    CREATE_FUNCIONARIO_CARGO_CADASTRO_SUCCESS,
    CREATE_FUNCIONARIO_CARGO_CADASTRO_FAILURE,
} from './actionTypes';


const initialState = { list: null, loading: false }


function funcionarioCargoCadastroReducer(state = initialState, action) {

    switch (action.type) {
        case NEW_FUNCIONARIO_CARGO_CADASTRO_SUCCESS:
            return {
                ...state,
                loading: false,
                registro: action.registro,
                isCadastroRapido: action.isCadastroRapido ?? false,
            }
        case LIST_FUNCIONARIO_CARGO_CADASTRO_PENDING:
        case FIND_FUNCIONARIO_CARGO_CADASTRO_PENDING:
        case DELETE_FUNCIONARIO_CARGO_CADASTRO_PENDING:
        case CREATE_FUNCIONARIO_CARGO_CADASTRO_PENDING:
        case TABLE_FUNCIONARIO_CARGO_CADASTRO_PENDING:
            return {
                ...state,
                loading: true,
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case CANCEL_FUNCIONARIO_CARGO_CADASTRO_RAPIDO_SUCCESS:
            return {
                ...state,
                isCadastroRapido: false,
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case LIST_FUNCIONARIO_CARGO_CADASTRO_SUCCESS:
            return {
                ...state,
                list: action.list,
                loading: false
            }
        case LIST_FUNCIONARIO_CARGO_CADASTRO_FAILURE:
            return {
                ...state,
                list: null,
                loading: false
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case TABLE_FUNCIONARIO_CARGO_CADASTRO_SUCCESS:
            return {
                ...state,
                table: action.table,
                loading: false
            }
        case TABLE_FUNCIONARIO_CARGO_CADASTRO_FAILURE:
            return {
                ...state,
                table: null,
                loading: false
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case FIND_FUNCIONARIO_CARGO_CADASTRO_SUCCESS:
            return {
                ...state,
                registro: action.registro,
                loading: false
            }
        case FIND_FUNCIONARIO_CARGO_CADASTRO_FAILURE:
            return {
                ...state,
                registro: null,
                loading: false
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case DELETE_FUNCIONARIO_CARGO_CADASTRO_SUCCESS: {
            return {
                ...state,
                loading: false
            }
        }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case CREATE_FUNCIONARIO_CARGO_CADASTRO_SUCCESS:
        case CREATE_FUNCIONARIO_CARGO_CADASTRO_FAILURE:
            return {
                ...state,
                loading: false,
                registro: action.registro,
                isCadastroRapido: false,
            }
        case DELETE_FUNCIONARIO_CARGO_CADASTRO_FAILURE:
            return {
                ...state,
                loading: false,
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        default:
            return state
    }
}

export { funcionarioCargoCadastroReducer };